/**
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

/**
 *
 * 接口模板，均封装至videoModule实例
 * @export
 * @class PlayerAPI
 */
export default class PlayerAPI {
  constructor(player) {
    // FlvPlayer | HlsPlayer | NativePlayer | FlashPlayer
    this.player = player;
  }

  play() {
    return this.player.play();
  }

  pause() {
    this.player.pause();
  }

  getIsPaused() {
    return this.player.getIsPaused();
  }

  getBuffered() {
    return this.player.getBuffered();
  }

  getCurrentTime() {
    return this.player.getCurrentTime();
  }

  setCurrentTime(t) {
    this.player.setCurrentTime(t);
  }

  getDuration() {
    return this.player.getDuration();
  }

  setLoop(v) {
    this.player.setLoop(v);
  }

  getLoop() {
    return this.player.getLoop();
  }

  getMuted() {
    return this.player.getMuted();
  }

  setMuted(b) {
    this.player.setMuted(b);
  }

  getNetworkState() {
    return this.player.getNetworkState();
  }

  setPlaybackRate(v) {
    this.player.setPlaybackRate(v);
  }

  getPlaybackRate() {
    return this.player.getPlaybackRate();
  }

  getPlayed() {
    return this.player.getPlayed();
  }

  getReadyState() {
    return this.player.getReadyState();
  }

  getSrc() {
    return this.player.getSrc();
  }

  setSrc(url) {
    this.player.setSrc(url);
  }

  getVolume() {
    return this.player.getVolume();
  }

  setVolume(v) {
    this.player.setVolume(v);
  }

  getControls() {
    return this.player.getControls();
  }

  setControls(val) {
    this.player.setControls(val);
  }

  getSeeking() {
    return this.player.getSeeking();
  }

  getSeekable() {
    return this.player.getSeekable();
  }

  getEstimateNetSpeed() {
    return this.player.getEstimateNetSpeed();
  }

  getRoot() {
    return this.player.getRoot();
  }

  getOwner() {
    return this.player.getOwner();
  }

  setStore(store) {
    this.player.setStore(store);
  }

  getStore() {
    return this.player.getStore();
  }

  emit2All(act, data) {
    this.getOwner() && this.getOwner().emit(act, data);
  }

  getDownloadSize() {
    return this.player.getDownloadSize();
  }

  getVideo() {
    return this.player.video;
  }

  handleTimeshiftPlay(opts) {
    this.player.handleTimeshiftPlay(opts);
  }

  // 获取cdn名称
  getCdnName() {
    return this.player.getCdnName();
  }

  //=================================================================================
  //=================================================================================
  //以下：未使用或不再使用，择机清理
  //以下：未使用或不再使用，择机清理
  getCrossOrigin() {
    return this.player.getCrossOrigin();
  }
  setCrossOrigin(v) {
    this.player.setCrossOrigin(v);
  }
  setAutoplay(v) {
    this.player.setAutoplay(v);
  }
  getAutoplay() {
    return this.player.getAutoplay();
  }
  setDefaultMuted(v) {
    this.player.setDefaultMuted(v);
  }
  getDefaultMuted() {
    return this.player.getDefaultMuted();
  }
  getEnded() {
    return this.player.getEnded();
  }
  getPreload() {
    return this.player.getPreload();
  }
  setPreload(v) {
    this.player.setPreload(v);
  }
  setIsOver(val) {
    this.player.setIsOver(val);
  }
  getIsOver() {
    return this.player.getIsOver();
  }
  getIsLive() {
    return this.player.getIsLive();
  }
}
